import { Controller } from "@hotwired/stimulus"
import { isDrillOpen, closeDrillPanel, removeDrillPanel } from "../lib/sidebar_drill"
import { COLLAPSED_CLASS, FOOTER_HIDDEN_CLASS } from "../lib/sidebar_collapse_state"

export default class extends Controller {
  static COLLAPSED_CLASS = COLLAPSED_CLASS
  static FOOTER_HIDDEN_CLASS = FOOTER_HIDDEN_CLASS

  connect() {
    this.boundClose = () => this.close()
    this.overlay = this.createOverlay()
  }

  disconnect() {
    this.close()
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.boundClose)
      this.overlay.remove()
      this.overlay = null
    }
  }

  // Both sidebars share `.gl-sidebar.main-sidebar`; pick the active one based
  // on the current sidebar-mode value so toggling the mobile overlay always
  // targets whichever sidebar is currently visible.
  get activeSidebar() {
    const mode = document.body.dataset.sidebarModeActiveValue || 'main'
    return document.querySelector(`.gl-sidebar.main-sidebar.gl-sidebar--mode-${mode}`)
      || document.querySelector('.gl-sidebar.main-sidebar')
  }

  toggle() {
    const sidebar = this.activeSidebar
    if (!sidebar) return

    const isOpen = sidebar.classList.contains('show')
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    const sidebar = this.activeSidebar
    if (!sidebar) return

    sidebar.classList.remove(
      this.constructor.COLLAPSED_CLASS,
      this.constructor.FOOTER_HIDDEN_CLASS
    )
    sidebar.classList.add('show')
    this.overlay.classList.add('show')
    document.body.classList.add('sidebar-open')
  }

  close() {
    // Strip `.show` off both sidebars defensively so a mode swap during an
    // open overlay can't leave the inactive sidebar stuck in shown state.
    const sidebars = document.querySelectorAll('.gl-sidebar.main-sidebar')
    if (sidebars.length === 0) return

    if (isDrillOpen()) {
      closeDrillPanel()
      removeDrillPanel()
    }

    sidebars.forEach((s) => s.classList.remove('show'))
    if (this.overlay) this.overlay.classList.remove('show')
    document.body.classList.remove('sidebar-open')
  }

  createOverlay() {
    let overlay = document.querySelector('.gl-sidebar-overlay')
    if (!overlay) {
      overlay = document.createElement('div')
      overlay.className = 'gl-sidebar-overlay'
      document.body.appendChild(overlay)
    }
    overlay.removeEventListener('click', this.boundClose)
    overlay.addEventListener('click', this.boundClose)
    return overlay
  }
}
